import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../lib/api';
import { ArrowLeft, Mail, CheckCircle2 } from 'lucide-react';
import BrandLogo from '../../components/common/BrandLogo';
import { toast } from 'sonner';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/password-reset/request', { email });
      setSubmitted(true);
    } catch (err) {
      toast.error('Fehler beim Senden');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <div className="mb-6">
          <BrandLogo height={40} />
        </div>
        <Link to="/login" className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-[#0F4C81] mb-6" data-testid="back-to-login">
          <ArrowLeft className="w-4 h-4" /> Zurück zum Login
        </Link>

        {!submitted ? (
          <>
            <h1 className="font-heading text-3xl font-semibold text-slate-900 mb-2">Passwort vergessen?</h1>
            <p className="text-slate-600 text-sm mb-6">Geben Sie Ihre E-Mail-Adresse ein. Wir schicken Ihnen einen Link zum Zurücksetzen Ihres Passworts.</p>

            <form onSubmit={handleSubmit} className="space-y-4" data-testid="forgot-form">
              <div>
                <label className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-1.5 block">E-Mail-Adresse</label>
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  data-testid="forgot-email-input"
                  className="w-full border border-slate-300 rounded-md px-3 py-2.5 text-sm focus:ring-2 focus:ring-[#0F4C81] focus:border-transparent outline-none"
                  placeholder="ihre@email.de"
                  autoFocus
                />
              </div>
              <button
                type="submit"
                disabled={loading || !email}
                data-testid="forgot-submit-btn"
                className="w-full bg-[#001d4c] hover:bg-[#0A365C] text-white font-medium rounded-md px-4 py-2.5 text-sm disabled:opacity-50"
              >
                {loading ? 'Wird gesendet...' : 'Link anfordern'}
              </button>
            </form>
          </>
        ) : (
          <div className="bg-emerald-50 border border-emerald-200 rounded-md p-5" data-testid="forgot-success">
            <div className="flex items-start gap-3">
              <CheckCircle2 className="w-5 h-5 text-emerald-600 flex-shrink-0 mt-0.5" />
              <div>
                <h2 className="font-heading text-base font-semibold text-emerald-900 mb-2">E-Mail gesendet</h2>
                <p className="text-sm text-emerald-800">
                  Falls ein Konto mit der Adresse <strong>{email}</strong> existiert, haben wir Ihnen gerade einen Link zum Zurücksetzen Ihres Passworts geschickt.
                </p>
                <p className="text-sm text-emerald-800 mt-2">
                  Der Link ist <strong>60 Minuten</strong> gültig. Bitte auch den Spam-Ordner prüfen.
                </p>
                <Link to="/login" className="inline-flex items-center gap-1.5 mt-4 text-sm font-medium text-[#001d4c] hover:underline">
                  <Mail className="w-4 h-4" /> Zum Login zurückkehren
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
